// removed by extract-text-webpack-plugin
module.exports = {"root":"Toolbox__root___2_nw9","title":"Toolbox__title___NrxI4","row":"Toolbox__row___1AqwX","colorPicker":"Toolbox__colorPicker___3-hSK","label":"Toolbox__label___17HQE","fontSize":"Toolbox__fontSize___f3D8Y","fontStyle":"Toolbox__fontStyle___clRfn","fontStylePickerItem":"Toolbox__fontStylePickerItem___2IIlL","fontStylePickerItemActive":"Toolbox__fontStylePickerItemActive___8AtNy"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/InputText/Toolbox/Toolbox.scss
// module id = 989
// module chunks = 0